import { createSaga } from './saga-helpers';

import * as Api from '../api/custom-fields-api';

const watchCreateCustomField = createSaga({
    type: 'CUSTOM_FIELD_CREATE',
    fn: Api.createCustomField,
    args: action => [action.payload.customField],
    successPayload: ({ id: customFieldId, options } = {}, action) => ({
        customFieldId,
        options,
        fragment: action.payload.customField
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        fragment: action.payload.customField
    })
});

const watchGetCustomFields = createSaga({
    type: 'CUSTOM_FIELDS_FETCH',
    fn: Api.fetchCustomFields,
    args: action => [action.payload],
    successPayload: ({ items, hasMore } = {}, action) => ({
        customFields: items,
        hasMore,
        ...action.payload
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        ...action.payload
    })
});

const watchGetCustomFieldsValues = createSaga({
    type: 'CUSTOM_FIELDS_VALUES_FETCH',
    fn: Api.fetchCustomFieldsValues,
    args: action => [action.payload.association, action.payload.associationId],
    successPayload: (values, action) => ({
        values,
        ...action.payload
    })
});

const watchUpdateCustomField = createSaga({
    type: 'CUSTOM_FIELD_UPDATE',
    fn: Api.updateCustomField,
    args: action => [action.payload.customFieldId, action.payload.customFieldProps],
    successPayload: customField => ({ customField })
});

const watchRemoveCustomField = createSaga({
    type: 'CUSTOM_FIELD_REMOVE',
    fn: Api.removeCustomField,
    args: action => [action.payload.customFieldId]
});

const watchSetCustomFieldValue = createSaga({
    type: 'CUSTOM_FIELD_VALUE_SET',
    fn: Api.setCustomFieldValue,
    args: action => [action.payload]
});

const watchSetCustomFieldsValue = createSaga({
    type: 'CUSTOM_FIELDS_VALUE_SET',
    fn: Api.setCustomFieldsValue,
    args: action => [action.payload.updateProps]
});

const sagas = [watchCreateCustomField, watchGetCustomFields, watchGetCustomFieldsValues, watchUpdateCustomField, watchRemoveCustomField, watchSetCustomFieldValue, watchSetCustomFieldsValue];

export default sagas;
